/* eslint-disable indent */
import dayjs from 'dayjs';
import { PagosResponseType } from '../hooks/getDeuda';
import { AlumnoType, CategoriasType, NivelesFemeninaFederadoType, NivelesFemeninaType, NivelesMasculinaFederadoType, NivelesMasculinaType, NivelesType, PayloadAlumnoType, nivelesFemenina, nivelesFemeninaFederado, nivelesMasculina, nivelesMasculinaFederado } from '../types/types';

export const monthToString = (month:number)=>{
  switch (month) {
    case 1: return 'Enero';
    case 2: return 'Febrero';
    case 3: return 'Marzo';
    case 4: return 'Abril';
    case 5: return 'Mayo';
    case 6: return 'Junio';
    case 7: return 'Julio';
    case 8: return 'Agosto';
    case 9: return 'Septiembre';
    case 10: return 'Octubre';
    case 11: return 'Noviembre';
    case 12: return 'Diciembre';
  }
};

export const monthToNumber = (month:string)=>{
  switch (month) {
    case 'Enero': return  1;
    case 'Febrero': return  2;
    case 'Marzo': return  3;
    case 'Abril': return  4;
    case 'Mayo': return  5;
    case 'Junio': return  6;
    case 'Julio': return  7;
    case 'Agosto': return  8;
    case 'Septiembre': return  9;
    case  'Octubre': return 10;
    case  'Noviembre': return 11;
    case  'Diciembre': return 12;
  }
};
export const getMesesAsistidos = (fechains:string) => {
  const months = [];
  const fechaInicial = dayjs(fechains).isAfter('2023-01-01', 'month') ? fechains : '2023-01-01';
  let dateStart = dayjs(fechaInicial);
  const dateEnd = dayjs();
  while (dateEnd.diff(dateStart, 'day') >= 10) {
    months.push({ month: monthToString(Number(dateStart.format('M'))) as string, year: dateStart.format('YYYY') });
    dateStart = dateStart.add(1, 'months');
  }
  return months;
};

export interface DeudaReportType {
  pagado: boolean;
  month: string;
  year: string;
}

export const generarReporteDeuda = (pagos:PagosResponseType[], alumno:AlumnoType) => {
  const mesesAsistidos = getMesesAsistidos(alumno.fechains);
  const reporte = [];
  for (const m of mesesAsistidos) {
    const hayDeuda = pagos.find((d) => m.year === d.year && d.month === m.month);
    reporte.push({ ...m, pagado: !hayDeuda });
  }
  return reporte;
};

export const getCuotasAdeudadas = (pagos:number, fechains:string) => {
  const mesesAsistidos = getMesesAsistidos(fechains);
  return mesesAsistidos.length - pagos;
};


export function groupBy(collection:any, property:string) {
  let i = 0, val, index;
  const  values = [], result = [];
  for (; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1)
      result[index].push(collection[i]);
    else {
      values.push(val);
      result.push([collection[i]]);
    }
  }
  return result;
}

export function titleCase(str:string) {
  const splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
}

export const getSectionName = (name:string) => {
  switch (name) {
    case 'asistencia' : return 'Asistencia';
    case 'planilla asistencia' : return 'Planilla Asistencia';
    case 'ver datos' : return 'Alumnos';
    case 'admin usuarios' : return 'Usuarios';
    case 'admin torneos' : return 'Torneos';
    case 'admin grupos' : return 'Grupos';
    case 'admi cuotas' : return 'Cuotas';
    case 'ver alertas' : return 'Alertas';
    case 'ver ingresos' : return 'Ingresos';
  }
};

export const getNivelOptions = (alumno?:PayloadAlumnoType) => {
  if (!alumno?.genero) return null;
  if (alumno.genero === 'M' && !alumno.federado) return nivelesMasculina;
  if (alumno.genero === 'M' && alumno.federado) return nivelesMasculinaFederado;
  if (alumno.genero === 'F' && !alumno.federado) return nivelesFemenina;
  if (alumno.genero === 'F' && alumno.federado)  return nivelesFemeninaFederado;
  return null;
};

export const getCategoria:(alumno?: PayloadAlumnoType) => CategoriasType = (alumno?: PayloadAlumnoType) => {
  if (!alumno) return null;
  // Calcula la edad que el alumno tendra al finalizar el año en curso.
  const edad = dayjs().endOf('year').year() - dayjs(alumno.fechanac, 'DD/MM/YYYY').year();
  if (alumno.genero === 'M' && !alumno.federado) {
    if (edad <= 4) return 'pre-escolar';
    if (edad === 5 || edad === 6) return 'pre-mini';
    if (edad === 7 || edad === 8) return 'mini';
    if (edad === 9 || edad === 10) return 'menor';
    if (edad === 11 || edad === 12) return 'infantil';
    if (edad === 13 || edad === 14) return 'cadete';
    if (edad >= 15) return 'juvenil';
  }
  if (alumno.genero === 'M' && alumno.federado) {
    if (edad <= 7) return 'mini';
    if (edad === 8 || edad === 9) return 'pre-infantil';
    if (edad === 10 || edad === 11) return 'infantil';
    if (edad === 12 || edad === 13) return 'cadete';
    if (edad === 14 || edad === 15) return 'juvenil';
    if (edad === 16 || edad === 17) return 'junior';
    if (edad >= 18 && edad < 35) return 'mayor';
    if (edad >= 35) return 'senior';
  }
  if (alumno.genero === 'F') {
    if (edad <= 5) return 'pre-escolar';
    if (edad === 6 || edad === 7) return 'pre-mini';
    if (edad === 8 || edad === 9) return 'mini';
    if (edad === 10 || edad === 11) return 'pre-infantil';
    if (edad === 12 || edad === 13) return 'infantil';
    if (edad === 14 || edad === 15) return 'juvenil';
    if (edad >= 16) return 'mayor';
  }
  return null;
};